<template>
    <v-container fluid style="padding-left: 16px;">
        <p>{{text}}</p>
    </v-container>
</template>
  
<script>
    import axios from 'axios';
    import {
        lineConfig
    } from '@/helpers/lineConfig';
    import OAuthRequest from '@/Entities/OAuthRequest'
    import linq from 'linq'
    import OAuthResult from '@/Entities/OAuthResult'
    import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

  export default {
    data() {
        return {
            text: 'Logging in..'
        }
    },
    async created() {
        const urlParams = new URLSearchParams(window.location.search);
            const code = urlParams.get('code');

        if(!code) return

        const result = await this.getToken(code)

        const { data } = await this.getProfile(result.token)
// console.log('profile', data);
        const emailAddress = `line-${data.userId}@thaisook.org` ;
        const auth = getAuth();
        signInWithEmailAndPassword(auth, emailAddress, lineConfig.defaultLinePassword)
        .then((userCredential) => {
            // Signed up 
            const user = userCredential.user;
            console.log('user', user);
            // console.log(user);
            // if( !user.phoneNumber || user.phoneNumber == undefined ){
            //     // firebase.auth().signOut()
            //     signOut(auth).then(() => {
            //         // Sign-out successful.
            //         // this.text = "Login failed";
            //     }).catch((error) => {
            //         console.log(error);
            //         // An error happened.
            //         // alert('Login failed');
            //         // this.text = "Login failed";
            //         // window.location.href = '/dashboard';
            //     });
            // }
            // ...
        })
        .catch((error) => {
            console.log('error', error);
            // const errorCode = error.code;
            // const errorMessage = error.message;
            // alert('Login failed');
            this.text = "Login failed";
            // window.location.href = '/dashboard';
            // ..
        });
    },
    methods: {
        async getProfile(token) {
            return await axios.get('https://api.line.me/v2/profile', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
        },
        async getToken(code) {
            const result = new OAuthRequest({
                code: code,
                clientId: lineConfig.VUE_APP_LINE_CLIENT_ID,
                clientSecret: lineConfig.VUE_APP_LINE_CLIENT_SECRET,
                redirectUri: lineConfig.VUE_APP_LINE_CALLBACK_URL
            })
            const params = new URLSearchParams()
            linq.from(result.getPostable()).select(x => params.append(x.key, x.value)).toArray()

            const { data } = await axios.post('https://api.line.me/oauth2/v2.1/token', params)
            return new OAuthResult(data)
        }
    }
  }
  </script>